<script lang="ts">
  import { Button } from "$lib/components/ui/button"
  import { MoveRight } from "lucide-svelte"
  import { getRequirement } from "../../utils"
  import { getContext } from "svelte"
  import { t, getCurrentLanguage } from "$lib/utils/i18n"

  interface Props {
    action: any
    isPreview?: boolean
    processAction: (action: any) => void
  }

  let { action, isPreview = false, processAction }: Props = $props()

  const language = getCurrentLanguage()

  // If inAppBrowser is true, we need to open the link
  // in the app to trigger Instagram bottom navigation bar
  const inAppBrowser = getContext("inAppBrowser")

  const entries = getRequirement(action, "Entries") || 0

  let description = $derived(
    (action.selectedAction || action)?.requirements.find(
      (r) => r.name === "Instructions",
    )?.value,
  )

  let buttonText = $derived(
    (action.selectedAction || action)?.requirements.find(
      (r) => r.name === "Button Text",
    )?.value,
  )

  let entryPluralized = $derived(
    t("widget_action_entries", {
      count: Number(entries),
    }),
  )

  function openUrl(action) {
    console.log("openUrl", action)
    // Debug: log all requirements to see what's available
    console.log("Requirements:", action.requirements)

    const url =
      getRequirement(action, "Url") ||
      getRequirement(action, "Youtube Url") ||
      getRequirement(action, "Channel Url")

    console.log("Found URL:", url)
    return url
  }

  let actionDetail = $state(action.actions)
  let url = $state("")

  function convertToEmbedUrl(watchUrl: string): string {
    if (!watchUrl) return ""
    const videoId = watchUrl.match(/(?:v=|\/)([\w-]{11})(?:\?|&|$)/)?.[1]
    return videoId ? `https://www.youtube.com/embed/${videoId}` : watchUrl
  }

  if (isPreview) {
    actionDetail = action.selectedAction
    url = convertToEmbedUrl(
      actionDetail.requirements.find((r) => r.name === "Url")?.value,
    )
  } else {
    url = convertToEmbedUrl(
      action.requirements.find((r) => r.name === "Url")?.value,
    )
  }

  // Add countdown state
  let countDown = $state(30)
  let timer: ReturnType<typeof setInterval>
  let isButtonEnabled = $state(true)

  // Start countdown when component mounts
  // onMount(() => {
  //   timer = setInterval(() => {
  //     if (countDown > 0) {
  //       countDown--
  //     } else {
  //       isButtonEnabled = true
  //       clearInterval(timer)
  //     }
  //   }, 1000)
  // })

  // Cleanup timer when component is destroyed
  // onDestroy(() => {
  //   if (timer) clearInterval(timer)
  // })
</script>

<div class="bg-white rounded-lg p-4 shadow-lg">
  <div class="mb-4">
    {#if actionDetail.name === "Watch our Youtube video"}
      <h4 class="text-sm font-medium mb-2">
        {t("widget_action_worth", { count: entries, entries: entryPluralized })}
      </h4>
      <div class="relative w-full aspect-video mb-4">
        <iframe
          class="absolute top-0 left-0 w-full h-full"
          src={url}
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    {:else}
      <div class="mb-4">
        {#if description}
          <div class="description-content text-black mb-10">
            {@html description}
          </div>
        {:else}
          <h4 class="text-sm font-medium mb-2">
            {t("widget_action_worth", {
              count: entries,
              entries: entryPluralized,
            })}
          </h4>
        {/if}
      </div>
    {/if}
  </div>

  <a
    href={openUrl(action)}
    target="_blank"
    class="block"
    onclick={() => processAction(action)}
  >
    <Button
      variant="default"
      class="w-full bg-black text-white hover:bg-gray-800 flex items-center justify-center gap-2"
    >
      {#if (action.selectedAction || action.actions)?.name === "Custom Action"}
        {buttonText}
      {:else}
        {(action.selectedAction || action.actions)?.translations?.[language]
          ?.name}
      {/if}
      <MoveRight />
    </Button>
  </a>
</div>
